// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./public/js/index.js");
var __webpack_exports__ = __webpack_require__("./public/css/less/app.less");
